import { setAnimationAction } from '../actions/setAnimationAction';

export function clearAnimationStore() {
    setAnimationAction();
}
